export default function Tooltip({
	title,
	description,
	position = 'top',
	className = '',
	panelStyle,
	children,
}) {
	return (
		<span
			className={`fairplay-rules-tooltip fairplay-rules-tooltip--${position}${className ? ` ${className}` : ''}`}
		>
			{children}
			<span className="fairplay-rules-tooltip__panel" style={panelStyle}>
				{title !== undefined && (
					<span className="fairplay-rules-tooltip__title">{title}</span>
				)}
				{description !== undefined && (
					<span className="fairplay-rules-tooltip__description">{description}</span>
				)}
			</span>
		</span>
	);
}